import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Modal from "react-modal";
import _ from "lodash";
import Constants from "../../AppConstants/Constants";
import Layout from "../../Layouts/LayoutMain";
import Items from "../../Components/Common/Items";
import WirelessPlan from "../../Components/Common/WirelessPlan";
import { selectProduct } from "../../Store/Catalog/Actions";
Modal.setAppElement("#react-app");

class FeaturedProducts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen   : false,
            parentProduct : {},
            deviceQuantity: 1,
            deviceAddedToCartId: null
        };

        this.showDetails = this.showDetails.bind(this);
        this.openPlanModal = this.openPlanModal.bind(this);
        this.closePlanModal = this.closePlanModal.bind(this);
        this.getCrossSellProducts = this.getCrossSellProducts.bind(this);
        this.addToCartCb = this.addToCartCb.bind(this);
    }

    openPlanModal() {
        this.setState({ modalIsOpen: true });
    }

    closePlanModal() {
        this.setState({ modalIsOpen: false });
    }

    getCrossSellProducts(data) {
        this.setState({ parentProduct: data });
    }

    showDetails(data, qty) {
        const { selectProduct, history, config: { KITS_CATEGORY_ID, DEVICES_CATEGORY_ID, ZEBRA_ACCESSORIES_CATEGORY_ID, ZEBRA_TC26_ACCESSORIES_CATEGORY_ID, ZEBRA_TC58_ACCESSORIES_CATEGORY_ID, ZEBRA_TC78_ACCESSORIES_CATEGORY_ID, PANASONIC_ACCESSORIES_CATEGORY_ID, PANASONIC_T1_ACCESSORIES_CATEGORY_ID, UNIVERSAL_ACCESSORIES_CATEGORY_ID, SAMSUNG_ACCESSORIES_CATEGORY_ID, VTRACK_CATEGORY_ID, LINEHAUL_CATEGORY_ID, RENTALS_CATEGORY_ID } } = this.props;

        selectProduct(data);

        switch (data.category.id) {
        case KITS_CATEGORY_ID:
            history.push(`${Constants.ENDPOINTS.KITS_DETAILS}?product=${data.id}&quantity=${qty}`);
            break;
        case DEVICES_CATEGORY_ID:
            history.push(`${Constants.ENDPOINTS.DEVICES_DETAILS}?product=${data.id}&quantity=${qty}`);
            break;
        case ZEBRA_ACCESSORIES_CATEGORY_ID:
            history.push(`${Constants.ENDPOINTS.ZEBRA_DETAILS}?product=${data.id}&quantity=${qty}`);
            break;
        case ZEBRA_TC26_ACCESSORIES_CATEGORY_ID:
            history.push(`${Constants.ENDPOINTS.ZEBRA_TC26_DETAILS}?product=${data.id}&quantity=${qty}`);
            break;
        case ZEBRA_TC58_ACCESSORIES_CATEGORY_ID:
            history.push(`${Constants.ENDPOINTS.ZEBRA_TC58_DETAILS}?product=${data.id}&quantity=${qty}`);
            break;
        case ZEBRA_TC78_ACCESSORIES_CATEGORY_ID:
            history.push(`${Constants.ENDPOINTS.ZEBRA_TC78_DETAILS}?product=${data.id}&quantity=${qty}`);
            break;
        case PANASONIC_ACCESSORIES_CATEGORY_ID:
            history.push(`${Constants.ENDPOINTS.PANASONIC_DETAILS}?product=${data.id}&quantity=${qty}`);
            break;
        case PANASONIC_T1_ACCESSORIES_CATEGORY_ID:
            history.push(`${Constants.ENDPOINTS.PANASONIC_T1_DETAILS}?product=${data.id}&quantity=${qty}`);
            break;
        case UNIVERSAL_ACCESSORIES_CATEGORY_ID:
            history.push(`${Constants.ENDPOINTS.UNIVERSAL_DETAILS}?product=${data.id}&quantity=${qty}`);
            break;
        case SAMSUNG_ACCESSORIES_CATEGORY_ID:
            history.push(`${Constants.ENDPOINTS.SAMSUNG_DETAILS}?product=${data.id}&quantity=${qty}`);
            break;
        case VTRACK_CATEGORY_ID:
            history.push(`${Constants.ENDPOINTS.VTRACK_DETAILS}?product=${data.id}&quantity=${qty}`);
            break;
        case LINEHAUL_CATEGORY_ID:
            history.push(`${Constants.ENDPOINTS.LINEHAUL_DETAILS}?product=${data.id}&quantity=${qty}`);
            break;
        case RENTALS_CATEGORY_ID:
            history.push(`${Constants.ENDPOINTS.RENTALS_DETAILS}?product=${data.id}&quantity=${qty}`);
            break;
        }
    }

    addToCartCb(id, quantity, categoryId) {
        const { config: { DEVICES_CATEGORY_ID } } = this.props;

        this.setState({
            deviceAddedToCartId: id,
            deviceQuantity: quantity
        });

        if (categoryId === DEVICES_CATEGORY_ID) {
            this.openPlanModal();
        }
    }

    renderMessage() {
        const { config: { DATA_PLANS_CATEGORY_ID } } = this.props;
        const { parentProduct } = this.state;
        const noReqProducts = _.filter(parentProduct.requiredProducts, p => !p.automaticallyAddToCart);

        if (noReqProducts && noReqProducts.length > 0 && noReqProducts[0].category.id === DATA_PLANS_CATEGORY_ID) {
            var shortDescArray = noReqProducts[0].shortDescription.split(" *");
            return (
                //  driven from the short description of the first item from the data plans
                <div className="highlighted-message">
                    {this.buildHighlightedMessage(shortDescArray)}
                </div>
            )
        } else {
            return null;
        }

    }

    buildHighlightedMessage(descArr) {
        var elements = _.map(descArr, (desc, index) => {
            if (index === 0) {
                return <div className="highlighted-message-body" key={index}>{desc}</div>
            } else {
                return <div className="highlighted-sub-container" key={index}><span className="highlighted-sub-message">*{desc}</span></div>
            }
            
        });
        return elements;
    }

    render() {
        const { isAuthenticated, newProducts, addToCart } = this.props;
        const { parentProduct, deviceAddedToCartId, deviceQuantity } = this.state;

        const noReqProducts = _.filter(parentProduct.requiredProducts, p => !p.automaticallyAddToCart);

        return (
            <Layout isAuthenticated={isAuthenticated}>
                <Items
                    items={newProducts}
                    filter="Featured Products"
                    addToCart={true}
                    showDetails={this.showDetails}
                    getCrossSellProducts={this.getCrossSellProducts}
                    addToCartCb={this.addToCartCb}
                    showLoadingStatus={true}
                    multipleCategories={true}
                />

                <Modal
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={this.closePlanModal}
                    contentLabel="select-wireless-plan"
                    className="modal-content"
                    overlayClassName="modal-container add-plan-modal modal-active"
                    shouldCloseOnOverlayClick={false}
                >
                    <div className="modal-body">
                        <div className="row justify-content-center">
                            <div className="col-md-12">
                                <h3>Would you like to add a data plan?</h3>
                            </div>
                        </div>
                        <div className="device-modal-message">
                            <div className="row">
                                <div className="col-md-12">
                                    {this.renderMessage()}
                                </div>
                            </div>
                        </div>
                        <div className="masonry">
                            <div className="row masonry__container masonry--active">
                                { noReqProducts &&
                                _.map(noReqProducts, product =>
                                    <WirelessPlan
                                        key={product.id}
                                        image={product.defaultPictureModel.fullSizeImageUrl}
                                        title={product.name}
                                        price={product.productPrice.price}
                                        product={product}
                                        addToCart={addToCart}
                                        productAttributes={product.productAttributes}
                                        closePlanModal={this.closePlanModal}
                                        deviceQuantity={deviceQuantity}
                                        selectedDeviceId={deviceAddedToCartId}
                                    />
                                )
                                }
                            </div>
                        </div>
                    </div>
                </Modal>
            </Layout>
        );
    }
}

function mapStateToProps(state) {
    return {
        config: state.config,
        newProducts: state.newProducts
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        selectProduct: selectProduct
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedProducts);
